export type AgentType =  "SUPPORT";

export const AGENT_API_PREFIX: Record<AgentType, string> = {
  SUPPORT: "helpdesk_agent"
};

export const AGENT_BASE_URLS: Record<AgentType, string | undefined> = {
  SUPPORT: `${import.meta.env.VITE_AGENT_AI_SUPPORT}`
};

export const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB
export const MAX_IMAGE_DIMENSION = 2048; // px

